export const SET_PRODUCTS = 'SET_PRODUCTS'
export const RESET_PRODUCTS = 'RESET_PRODUCTS'
